export default (type, ...argNames) => (...args) => {
  const action = { type }
  for (let i = 0; i < argNames.length; i++) {
    action[argNames[i]] = args[i]
  }
  return action
}
